export enum RoleEnum {
  CarDealer = 'sales',
  Credit = 'emsp_kredit',
  Developer = 'ladestander_admin',
  Ekc = 'emsp_ekc',
  Emobility = 'emsp_superuser',
  Pkc = 'emsp_pkc',
  Screening = 'emobscreening',
  Subcontractor = 'subcontractor',
  Tsc = 'emsp_teknisksupport',
}
